import * as TechRegisterAction from './tech-register.actions';

export {TechRegisterAction as TechRegisterActions};
